import Script from "next/script";

const AppleSignin = () => {
	return (
		<Script
			id="apple-signin"
			src="https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js"
			strategy="lazyOnload"
		/>
	);
};

export default AppleSignin;
